import { render, staticRenderFns } from "./PaymentCompleted.vue?vue&type=template&id=e6c06bde"
import script from "./PaymentCompleted.vue?vue&type=script&lang=js"
export * from "./PaymentCompleted.vue?vue&type=script&lang=js"
import style0 from "./PaymentCompleted.vue?vue&type=style&index=0&id=e6c06bde&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports